import React, { useState, useEffect } from "react";

const RegionWiseProcureMIS = () => {
  const [datelist, setDatelist] = useState([]);

  const FillDetail = () => {
    var Datelst = [
      { name: " Farmers covered", reportUrl: "" },
      { name: "Deals Done", reportUrl: "" },
      { name: " Crops Procured", reportUrl: "" },
      { name: "Farmer Payments Done", reportUrl: "" },
    ];
    setDatelist(Datelst);
  };

  useEffect(() => {
    FillDetail();
  }, []);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3"> &nbsp; &nbsp;Region Wise Report Detail </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3 text-right"></div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      {datelist &&
                        datelist.map((itm, i) => {
                          return (
                            <div className="col-3" key={i}>
                              <a type="submit" href={itm.reportUrl}>
                                {itm.name}
                              </a>
                            </div>
                          );
                        })}
                    </div>
                  </div>

                  <div className="card-footer clearfix"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default RegionWiseProcureMIS;
